import useDocumentTitle from "@/hooks/useDocumentTitle";
import AddPatientForm from '@patientMenu/form/AddPatientForm';
import { PatientCreate, PatientCreateSchema } from '@schema/patient';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { ModalFormWrapper } from '@/components/ui/ModalFormWrapper';
import { useProfile } from '@hooks/useProfile';
import { useEffect } from 'react';
import { useCreatePatient } from '@hooks/usePatient.ts';

interface AddPatientProps {
  onClose: () => void;
}

export default function AddPatient({ onClose }: AddPatientProps) {
  useDocumentTitle("Patients - Add");
  const profileQuery = useProfile();
  const createPatientMut = useCreatePatient();
  const form = useForm<PatientCreate>({
    resolver: zodResolver(PatientCreateSchema),
    defaultValues: {
      clinicId: '',
      orthodontistId: '',
    },
  });

  useEffect(() => {
    if (profileQuery.data) {
      form.reset({
        clinicId: profileQuery.data.orthodontist?.clinicId || '',
        orthodontistId: profileQuery.data.orthodontist?.id || '',
      });
    }
  }, [profileQuery.data, form]);

  if (profileQuery.isLoading) {
    return null;
  }

  const handleSubmit = (data: PatientCreate) => {
    createPatientMut.mutate(data, {
      onSuccess: () => {
        form.reset();
        onClose();
      },
      onError: (error) => {
        console.error('Error creating patient:', error);
      },
    });
  };

  return (
    <ModalFormWrapper form={form} submitText="Add" submitButton="default" onSubmit={handleSubmit} onClose={onClose}>
      <AddPatientForm />
    </ModalFormWrapper>
  );
}
